import type { Slice } from '@tiptap/pm/model';
import type { EditorView } from '@tiptap/pm/view';
import { insertImageFile } from './insert-image-file';

/**
 * Inserts dropped image files as base64 data URLs. Without this, the browser falls
 * back to its default drop behaviour and navigates to the image URL. The handler
 * returns false for non-image drops (text/uri/internal node moves) so ProseMirror's
 * own drop logic (link drops, intra-doc moves) keeps working.
 */
export const handleImageDrop = (
  view: EditorView,
  event: DragEvent,
  isEditorAlive: () => boolean,
  _slice: Slice,
  moved: boolean
): boolean => {
  // Internal node-drag: let ProseMirror move the node itself.
  if (moved) {
    return false;
  }

  const files = event.dataTransfer?.files;
  if (!files || files.length === 0) {
    return false;
  }

  for (const file of files) {
    if (!file.type.startsWith('image/')) {
      continue;
    }

    event.preventDefault();
    insertImageFile(view, file, isEditorAlive);
    return true;
  }

  return false;
};
